<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper">
                <div class="modal-container">

                    <div class="modal-header">
                        <slot name="header">
                            Modal Header
                        </slot>
                    </div>

                    <div class="modal-body px-0 px-md-3">
                        <slot name="body">
                            <div v-for="item in items">{{log(item)}}</div>
                        </slot>
                    </div>
                    <div class="modal-footer"
                        :class="foot.cls"
                    >
                        <slot name="footer">
                            <span class="cursor-pointer" @click="$emit('close')">Close</span>
                        </slot>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
	// add imports here

	//ADD JSDOC HERE!!!!!
	export default {
		props: ['items', 'footer'],
		created() {
		},
		destroyed() {
		},
		mounted() {
			if (typeof this.footer !== 'undefined' && this.footer !== null &&  'cls' in this.footer) {
				this.foot.cls = this.footer.cls
			}
		},
		data() {
			return {
				foot: {
					cls: ''
				}
			}
		},
		methods: {
			log(item) {
				console.log('item', item);
			},
		},
		computed: {}
	}
</script>
<style>

</style>



// WEBPACK FOOTER //
// app/Shared/Resources/Assets/js/components/notifications/SimpleModal.vue?18d8517c